export default {
  all: 'All',
  company: 'Company',
  personal: 'Personal',
} as const;
